import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { map, mergeMap, pluck } from 'rxjs/operators';
import { sendEnquirySuccess } from '@bridebook/web/lib/enquiries/actions';
import { OnboardingAction } from '@bridebook/web/lib/onboarding/actions';
import { CreateEnquiryResponse } from '@bridebook/web/lib/onboarding/types';
import { ActionWithPayload } from '@bridebook/web/lib/types';

/**
 * Handles successful onboarding enquiries
 */
export const sendEnquirySuccessfulEpic = (
  action$: Observable<ActionWithPayload<CreateEnquiryResponse[]>>,
) =>
  action$.pipe(
    ofType(OnboardingAction.SendEnquiriesSuccess),
    pluck<ActionWithPayload<CreateEnquiryResponse[]>, CreateEnquiryResponse[]>('payload'),
    mergeMap((enquiries) => enquiries),
    map(({ supplier }) => sendEnquirySuccess(supplier, true, true)),
  );
